import { Link } from "react-router-dom";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen grid place-items-center bg-background text-foreground px-6" data-testid="payment-cancel-page">
            <div className="max-w-md w-full border border-border bg-card/40 p-10">
                <div className="overline">Cancelled</div>
                <div className="font-display text-3xl mt-2">No worries.</div>
                <p className="text-sm text-muted-foreground mt-4">Your card wasn't charged. The free tier keeps working as usual — upgrade anytime.</p>
                <div className="mt-8 flex gap-3">
                    <Link to="/pricing" data-testid="back-to-pricing" className="flex-1 text-center bg-primary text-primary-foreground py-3 font-medium">Back to pricing</Link>
                    <Link to="/app" data-testid="back-to-app" className="flex-1 text-center border border-border py-3">Back to app</Link>
                </div>
            </div>
        </div>
    );
}
